export enum UserRole {
  ADMIN = "ADMIN",
  TUTOR = "TUTOR",
  TUTOR_ADMIN = "TUTOR_ADMIN",
}

export interface User {
  id: string;
  name: string;
  role: UserRole;
  avatarUrl: string;
  assignedCentreIds: string[];
  assignedClassIds: string[];
}

export interface Centre {
  id: string;
  name: string;
}

export interface ClassOption {
  id: string;
  name: string;
}

export enum PrintStatus {
  NOT_YET_STARTED = "not_yet_started",
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  FAILED = "failed",
}

export interface PrintRecord {
  id: string;
  datePrinted: string; // ISO Date string
  centreId: string;
  centreName: string;
  dayOfWeek: string;
  classId: string;
  className: string; // Full display string: "Year 6 Science 4pm..."
  tutorName: string;
  subject: string;
  topic: string;
  bookletId: string;
  bookletName: string;
  bookletDrivePath: string;
  bookletDriveUrl: string;
  bookletDescription?: string;
  printCount: number;
  requestedBy: string;
  requestedDate: string;
  status?: PrintStatus;
  notes?: string;
}

export interface FilterState {
  centreId: string;
  dayOfWeek: string;
  classId: string;
  searchQuery: string;
}
